/** @jsx jsx */
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { Flex, Text, jsx } from 'theme-ui'

const FooterLegal = ({ links }) => {
  return (
    <Flex
      color="white"
      sx={{
        flexDirection: ['column', null, 'row'],
        fontSize: '16px',
        justifyContent: ['center', null, 'space-between'],
        lineHeight: '22px',
        textAlign: ['center', null, 'left'],
      }}
    >
      <Text as="p" mr={[0, 3]} sx={{ flexShrink: '0', order: [1, null, 0] }}>
        {`Copyright © ${new Date().getFullYear()} Maker Wine Company`}
      </Text>
      <Flex
        mb={[2, null, 0]}
        sx={{
          flexDirection: ['column', null, 'row'],
          justifyContent: 'center',
        }}
      >
        {links.map(({ footerNavTitle, name, slug }) => {
          return (
            <Text
              as="p"
              key={slug}
              mb={[3, null, 0]}
              ml={[0, null, 3, 5]}
              sx={{ textAlign: 'center' }}
            >
              <Link
                to={`/${slug}/`}
                sx={{
                  color: 'white',
                  textDecoration: 'underline',
                }}
              >
                {footerNavTitle || name}
              </Link>
            </Text>
          )
        })}
      </Flex>
    </Flex>
  )
}

FooterLegal.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    })
  ),
}

export default FooterLegal
